globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Slider = (function(){

  Slider.selector = '[data-plugin="limitless.slider"]';

  Slider.init = function($html) {
    $html.find(Slider.selector).each(function() {
      new Slider($(this));
    })
  }

  function Slider($html) {
    this.$html        = $html;
    this.options      = this.$html.data('plugin-options') || {};
    this.$input       = this.$html.find('input[name="' + this.options.input_name + '"]');
    this.$valueLabel  = this.$html.closest('.form-group').find('.slider-value');
    this.userMinValue = parseInt(this.$input.attr("data-user-min-value"));
    this.defaults     = {
      range: "min",
      min: 1,
      max: 100,
      step: 1,
      value: this.$input.val()
    };

    this.init();
  }

  Slider.prototype = {
    init: function(){
      var Slider = this;

      options = $.extend({}, Slider.defaults, Slider.options, true);

      Slider.$html.slider($.extend({}, options, {
        slide: function(event, ui) {
          Slider.$input.val(ui.value).trigger("change");
          Slider.updateValueLabel(ui.value);

          if (Slider.userMinValue && Slider.userMinValue > parseInt(Slider.$input.val())) {
            Slider.$input.val(Slider.userMinValue).trigger("change");
            Slider.updateValueLabel(Slider.userMinValue);
            return false;
          }
        },
        change: function(event, ui) {
          Slider.$input.val(ui.value).trigger("change");
          Slider.updateValueLabel(ui.value);
          userMinValue = parseInt(Slider.$input.attr("data-user-min-value"));

          if (userMinValue && userMinValue > parseInt(Slider.$input.val())) {
            Slider.$input.val(Slider.userMinValue).trigger("change");
            Slider.updateValueLabel(Slider.userMinValue);
            ui.value = Slider.$input.val();
            $(this).slider("value", Slider.$input.val())
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        }
      }, true));

      var pipsOptions = Slider.options.pips !== undefined ? Slider.options.pips : {rest: 'label'};
      if (pipsOptions) { Slider.$html.slider('pips', pipsOptions); }
    },

    updateValueLabel: function(value) {
      if (this.$valueLabel.length) {
        var suffix = this.options.value_suffix || '';
        this.$valueLabel.text(value + suffix);
      }
    },
  }

  return Slider;

})();
